import { View } from 'rune-ts';
import { MembershipConstantS } from '../../../../features/Membership/outbound/share';
import { membership_menu_name } from '../../../../../../modules/MShop/App/Mypage/S/Constant/mypage';
import { MyPageTabsHookError } from '../views/MyPageTabs/MyPageTabsError';

export const MY_PAGE_MENU_MAP = {
  orders: {
    get title() {
      return ET('mps2::mypage::order::title');
    },
    get href() {
      return `/${ET.lang}/@/orders`;
    },
  },
  membership: {
    title: membership_menu_name,
    get href() {
      return `/${ET.lang}/@/${MembershipConstantS.my_memberships_path}`;
    },
  },
  reviews: {
    get title() {
      return ET('mps2::mypage::review::title');
    },
    get href() {
      return `/${ET.lang}/@/my_review`;
    },
  },
  like: {
    get title() {
      return ET('mps2::mypage::like::title');
    },
    get href() {
      return `/${ET.lang}/@/my_like`;
    },
  },
  my_recent: {
    get title() {
      return ET('mps2::mypage::recent::title');
    },
    get href() {
      return `/${ET.lang}/@/my_recent`;
    },
  },
  faq: {
    title: 'FAQ',
    get href() {
      return `/${ET.lang}/@/help`;
    },
  },
  creator_question: {
    get title() {
      return ET('mps2::mypage::creator_question::title');
    },
    get href() {
      return `/${ET.lang}/@/my_question`;
    },
  },
};

export const MY_PAGE_TABS_MAP = {
  product: 'product',
  creator: 'creator',
  paymethod: 'paymethod',
  membership: 'membership',
  support: 'support',
  commission: 'commission',
} as const;

/**
 * 마이페이지 탭에서 쓰이는 프로퍼티
 * @property {string} key - MyPageTabs 컴포넌트에서 key를 통해 선택된 탭을 매칭
 * @property {boolean} selected - 현재 보이는 탭인지 아닌지 여부
 * @property {string} value - 탭에서 보여줄 타이틀
 * @property {View} view - 헤드리스로 탭에 렌더할 뷰
 * @property {function} preRenderOnSelectedHook - 탭에서 선택된 뷰가 렌더 되기 전에 실행할 콜백 훅
 * @property {function} postRenderOnSelectedHook - 탭에서 선택된 뷰가 렌더 된 후 실행할 콜백 훅
 * @property {function} renderOnRefreshHook - 앱이나 웹에서 뒤/앞으로가기 등 탭이 다시 보여지면 실행할 훅, 훅을 사용하지 않으면 캐시된 데이터(ssr 데이터)를 사용
 * @property {function} catchOnErrorHook - 훅에서 에러가 발생하면 실행할 훅
 */
export type MyPageTabsOptionMap<T extends object = object> = {
  [K in keyof typeof MY_PAGE_TABS_MAP]?: {
    value: string;
    selected: boolean;
    view: View<T>;
    preRenderOnSelectedHook?(view?: View<T>): Promise<void> | void;
    postRenderOnSelectedHook?(view?: View<T>): Promise<void> | void;
    renderOnRefreshHook?(view?: View<T>): Promise<void> | void;
    /**
     * catchOnErrorHook
     * @param myPageTabHookError - MyPageTabsHookError 클래스를 상속 받은 커스텀 에러를 받음
     * @param view
     *
     * MyPageTabsHookError 훅을 상속 받은 PreRenderOnSelectedHookError.. 에러를 내려 받기 때문에 정적 메서드인 is로 어느 훅에서 에러가 발생했는지 확인 가능
     *
     * if(PreRenderOnSelectedHookError.is(myPageTabHookError)) {
     *   // ... 에러처리
     * }
     */
    catchOnErrorHook?(myPageTabHookError?: MyPageTabsHookError, view?: View<T>): Promise<void> | void;
  };
};

/**
 * 마이페이지 메뉴에서 쓰이는 프로퍼티
 * @property {string} href - 메뉴가 클릭 되면 이동할 주소
 * @property {string} title - 메뉴에서 보여줄 타이틀
 * @property {boolean} active - 메뉴가 클릭되었는지 여부
 */
export type MyPageMenuOptionMap = {
  [K in keyof typeof MY_PAGE_MENU_MAP]: {
    href: string;
    title: string;
    active: boolean;
  };
};

export type MyPageMenuOptions = MyPageMenuOptionMap[keyof typeof MY_PAGE_MENU_MAP][];
